import { Container, SpinnerIcon } from "./styled"
import AnimatedPage from "../AnimatedPage";

const Loading = () => (
    <AnimatedPage>
    < Container >
        <SpinnerIcon />
    </Container >
    </AnimatedPage>
);

export default Loading;